import script from "./CompanyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProfile.vue?vue&type=style&index=0&id=4506cd84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4506cd84"]])

export default __exports__